import CountryDropdown from './CountryDropdown';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import { withModel } from '../../../data-providers/model';

const enhance = compose(
  withModel,
  withProps(({
    countries = [],
    model: { eagleModel: { countries: eagleCountries = [] } }
  }) => {
    const translatedCountries = eagleCountries
      .filter(iso => iso !== 'UM')
      .map(iso => {
        const translatedCountry = countries.find(country => country.code === iso) || {};

        return {
          value: iso,
          label: translatedCountry.name || iso,
        };
      });

    return { countries: translatedCountries };
  }),
);

export default enhance(CountryDropdown);



// WEBPACK FOOTER //
// ./src/client/js/view/components/UserForm/CountryDropdown/index.js